import { createApiResource, UnpagedListHookResult, UnpagedListResource } from '../apiResourceFactory';
import { ServiceTitanAPI } from '../apiService';
import { Technician, ServiceTitanTechnicianQueryParams } from '../apiTypes.shim';

interface ServiceTitanTechnicianResource extends UnpagedListResource<Technician, ServiceTitanTechnicianQueryParams> {
  useUnpagedListCached: () => UnpagedListHookResult<Technician>;
}

export const createServiceTitanTechnicianResource = (companyId: string): ServiceTitanTechnicianResource => {
  const { useUnpagedList, unpagedList, unpagedListQueryKey } = createApiResource(
    ServiceTitanAPI,
    `${companyId}/technicians`
  );
  return {
    useUnpagedList,
    unpagedList,
    unpagedListQueryKey,
    useUnpagedListCached: () => useUnpagedList({}, { refetchOnMount: false })
  };
};
